import { formatCatalogMoney } from "@/lib/catalog/money";

export interface ProductPriceBlockProps {
  readonly currencyCode: string;
  readonly salePrice: number;
  readonly wholesaleMinQuantity: number | null;
  readonly wholesalePrice: number | null;
  readonly variant?: "compact" | "detail";
}

export function ProductPriceBlock({
  currencyCode,
  salePrice,
  wholesaleMinQuantity,
  wholesalePrice,
  variant = "compact",
}: Readonly<ProductPriceBlockProps>) {
  if (variant === "detail") {
    return (
      <div className="grid grid-cols-2 overflow-hidden rounded-xl border border-outline-variant bg-surface shadow-sm">
        <PriceCell label="Precio por menor" value={formatCatalogMoney(salePrice, currencyCode)} />
        <PriceCell
          label="Precio por mayor"
          helper={wholesaleMinQuantity ? `Desde ${wholesaleMinQuantity} unidades` : undefined}
          value={wholesalePrice ? formatCatalogMoney(wholesalePrice, currencyCode) : "No disponible"}
          valueClassName="text-secondary"
        />
      </div>
    );
  }

  return (
    <div className="mt-1 space-y-0.5">
      <p className="text-sm font-extrabold text-foreground">
        {formatCatalogMoney(salePrice, currencyCode)}{" "}
        <span className="text-[11px] font-semibold text-muted">Menor</span>
      </p>
      {wholesalePrice && wholesaleMinQuantity ? (
        <p className="truncate text-sm font-extrabold text-secondary">
          {formatCatalogMoney(wholesalePrice, currencyCode)}{" "}
          <span className="text-[11px] font-semibold">
            Mayor desde {wholesaleMinQuantity} uds.
          </span>
        </p>
      ) : null}
    </div>
  );
}

interface PriceCellProps {
  readonly helper?: string;
  readonly label: string;
  readonly value: string;
  readonly valueClassName?: string;
}

function PriceCell({
  helper,
  label,
  value,
  valueClassName = "text-primary",
}: Readonly<PriceCellProps>) {
  return (
    <div className="border-r border-outline-variant px-4 py-3.5 last:border-r-0">
      <span className="block text-[11px] font-semibold leading-4 text-muted">{label}</span>
      <span className={`mt-1 block text-xl font-extrabold leading-6 ${valueClassName}`}>
        {value}
      </span>
      {helper ? (
        <span className="mt-1 block text-[11px] font-bold leading-4 text-muted">{helper}</span>
      ) : null}
    </div>
  );
}
